module.exports.kebabize = function kebabize(string) {
  return string.replace(' ', '-');
};
